<template>
    <nav>
        <div v-if="list.length > 0 && search" :class="['search', { 'active-search': keyword }]">
            <div>
                <i class="icon-search"></i>
                <input
                    id="forAT_search-Sidebar"
                    :value="keyword"
                    class="search-input"
                    maxlength="30"
                    :placeholder="searchPlaceholder"
                    @input="debounceSetKeyword($event.target.value)"
                />
                <label for="forAT_search-Sidebar" class="label-for-screen-reader">
                    {{ searchPlaceholder }}
                </label>
                <button @click="setKeyword('')"><i class="icon-close"></i></button>
            </div>
        </div>
        <ul id="forAT_list-Sidebar" class="nav height-check" :class="{ fix: fixNav }">
            <RouterLink
                v-for="item in searchWithCurrentItem"
                :key="item.id"
                tag="li"
                :to="{ name: `${parentName}.edit`, params: { id: item.id } }"
            >
                <template v-if="showIcons">
                    <i v-if="isActiveIconShown(item)" :class="activeIcon"></i>
                    <i v-else :class="'icon-empty'"></i>
                </template>
                <img
                    v-if="item.icon"
                    :src="`${iconSrc}${item.icon}_24px.png`"
                    alt=""
                    width="24"
                    height="24"
                />
                <a class="nav-link" :title="item.name" @click="clearMessages" v-text="item.name"></a>
                <button
                    v-show="!item.isUsed"
                    class="icon-delete"
                    @click.prevent="deleteItem(item.id)"
                ></button>
            </RouterLink>
            <RouterLink
                v-if="$route.name == parentName + '.add'"
                tag="li"
                :to="{ name: parentName + '.add' }"
            >
                <a class="nav-link">{{ addNewText }}</a>
            </RouterLink>
        </ul>
        <h3 v-if="keyword && !filteredList.length && search">
            {{ $t('common.searchNoResult', { val: keyword }) }}
        </h3>
    </nav>
</template>

<script type="text/babel">
import fixingEditForm from '../common/fixingEditForm';
import mappingState from '../common/mappingState';

import Simplebar from 'simplebar-vue';
import { mapState, mapActions } from 'vuex';
import { DEBOUNCE_SEARCH } from '../../constants';
import debounce from 'lodash-es/debounce';

export default {
    components: {
        Simplebar,
    },
    mixins: [fixingEditForm, mappingState],

    props: {
        parentName: {
            type: String,
            required: true,
        },

        list: {
            type: Array,
            required: true,
        },

        currentId: {
            // can be int or null
            validator: prop => typeof prop === 'number' || prop === null,
            required: true,
        },

        searchPlaceholder: {
            type: String,
            default: '',
        },

        addNewText: {
            type: String,
            default: '',
        },

        iconSrc: {
            type: String,
            default: '',
        },

        search: {
            type: Boolean,
            default: true,
        },

        reportMode: {
            type: String,
            default: '',
        },

        isActiveIconShown: {
            type: Function,
            default: () => false,
        },

        showIcons: {
            type: Boolean,
            default: false,
        },

        activeIcon: {
            type: String,
            default: '',
        },

        collapsed: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            debounceSetKeyword: debounce(searchText => this.setSearchText(searchText), DEBOUNCE_SEARCH),
        };
    },

    computed: {
        ...mapState({
            keyword: state => state.header.keyword,
        }),

        filteredList() {
            if (this.searchKeyword && this.search) {
                return this.list.filter(item => item.name.toLowerCase().includes(this.searchKeyword));
            }
            return this.list;
        },

        searchWithCurrentItem() {
            if (this.search && this.searchKeyword && this.currentId !== null) {
                let listWithoutCurrent = this.filteredList.filter(item => item.id !== this.currentId);
                let currentItem = this.list.find(item => item.id === this.currentId);
                if (currentItem) {
                    listWithoutCurrent.unshift(currentItem);
                    return this.collapsed || this.reportMode === 'add'
                        ? this.filteredList
                        : listWithoutCurrent;
                }
            }
            return this.filteredList;
        },
    },

    methods: {
        ...mapActions({
            clearMessages: 'popup/clearMessages',
        }),

        setSearchText(value) {
            this.setKeyword(value);
        },

        deleteItem(id) {
            this.$emit('delete', id);
        },
    },
};
</script>
